var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-logo"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":"Manchester University NHS Foundation Trust"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }